import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { SellerProfile } from "@/pages/marketplace/Sellers";

// /marketplace/loja/:id → canonical /negocios/:id; falls back to the legacy shop page when the seller is hidden from the directory.
export default function SellerRedirect() {
  const { id } = useParams();
  const [state, setState] = useState(null);
  useEffect(() => {
    api.get(`/directory/${id}`).then(r => setState({ to: r.data.redirect_to || `/negocios/${id}` })).catch(() => setState({ fallback: true }));
  }, [id]);
  if (!state) return <div className="page pt-8" data-testid="seller-redirect-loading"><div className="h-40 bg-white rounded-2xl border border-zinc-200 animate-pulse" /></div>;
  if (state.fallback) return <SellerProfile />;
  return <Navigate to={state.to} replace />;
}
